import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface RatingDistribution {
  rating: number;
  count: number;
  percentage: number;
}

export const useCSATRatingDistribution = (daysRange: number = 30) => {
  return useQuery({
    queryKey: ['csat-rating-distribution', daysRange],
    queryFn: async (): Promise<RatingDistribution[]> => {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - daysRange);

      const { data, error } = await supabase
        .from('csat_responses')
        .select('rating')
        .gte('created_at', startDate.toISOString());

      if (error) throw error;

      const totalResponses = data?.length || 0;
      
      if (totalResponses === 0) {
        return [1, 2, 3, 4, 5].map(rating => ({
          rating,
          count: 0,
          percentage: 0,
        }));
      }

      // Contar respostas por rating
      const ratingCounts: Record<number, number> = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      
      data?.forEach(response => {
        const rating = response.rating;
        if (rating >= 1 && rating <= 5) {
          ratingCounts[rating] = (ratingCounts[rating] || 0) + 1;
        }
      });

      // Calcular percentuais
      return [1, 2, 3, 4, 5].map(rating => ({
        rating,
        count: ratingCounts[rating] || 0,
        percentage: totalResponses > 0 
          ? Math.round((ratingCounts[rating] || 0) / totalResponses * 100 * 10) / 10 
          : 0,
      }));
    },
  });
};

